import $ from 'jquery'
// 引入i18n这个很重要，切换中英文更能依赖
import i18n from 'jqi18n'
//引入鼠标滚动依赖
import mousewheel from 'mousewheel'


$(function () {

  //手机端的英文同样也要中英文转换
  $('.m_container>ul>li').mouseover(function () {
    let res = $(this)[0].innerText
    $(this)[0].innerText = changeLanguage(res)
  })
  $('.m_container>ul>li').mouseout(function () {
    let res = $(this)[0].innerText
    $(this)[0].innerText = changeLanguage(res)
  })


  /*点击三条横线事件*/
  $(".clear>input[type='checkbox']").click(
    function (e) {
      let res = $(e.target).is(':checked')
      if (res) {

        $('.mobil_header')
          .css({
            'background-color': 'rgb(255,69,0)',
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'box-sizing': 'border-box',
          })

        $('.m_bottom').css({
          'display': 'flex',
          'justify-content': 'center'
        })

        // 控制手机端菜单显示
        $('.m_container ul').css({
          'display': 'flex',
          'flex-direction': 'column',
          'justify-content': 'center',
          'height': '100%',
          // 'color': 'white'
        })

        //控制图标为白色
        $('.m_logo > img').attr('src', 'http://qiniu.shujunjun.club/logodesign.png')
      } else {
        $('.mobil_header').css({
          'display': 'block',
          // 'background-color': 'rgb(255,255,255)',
          // 'position': 'static',
          'box-sizing': 'border-box',
          'position': 'fixed',
          'top': '0',
          'left': '0',
          'width': '100%',
          'height': '70px',
          'background-color': 'white'
        })

        $('.m_container ul').css({
          'display': 'none'
        })

        $('.m_bottom').css({
          'display': 'none',
        })

        //还原图标
        $('.m_logo > img').attr('src', 'http://qiniu.shujunjun.club/logo.svg')
      }

    }
  )


  //鼠标滚动事件
  $('.main').mousewheel(function (e) {
    let target = e.deltaY
    // 鼠标向下滚动
    if (target === -1) {
      $('.header').hide();
      $('.m_top').hide();
    }
    // 鼠标向上滚动
    if (target === 1) {
      $('.header').fadeIn()
      $('.m_top').fadeIn()
    }

  });

})

//中应为转换
function changeLanguage(res) {
  if (res === '案例') {
    return 'works'
  }
  if (res === '关于') {
    return 'about'
  }
  if (res === '联系') {
    return 'connect'
  }
  if (res === 'works') {
    return '案例'
  }
  if (res === 'about') {
    return '关于'
  }
  if (res === 'connect') {
    return '联系'
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/js/oaim.js
// module id = null
// module chunks = 